import { withAppCrashIfException } from 'epic';
import { addToScheduledRunEpic } from 'epic/scheduledRuns/addToScheduledRunEpic';
import { checkNameEpic } from 'epic/scheduledRuns/checkNameExistsEpic';
import { createScheduledRunEpic } from 'epic/scheduledRuns/createScheduledRunEpic';
import { deleteScheduledRunEpic } from 'epic/scheduledRuns/deleteScheduledRunEpic';
import { pauseScheduledRunEpic } from 'epic/scheduledRuns/pauseScheduledRunEpic';
import { requestScheduledRunOccurrenceDetailEpic } from 'epic/scheduledRuns/requestScheduledRunOccurrenceDetailEpic';
import { requestScheduledRunOccurrencesEpic } from 'epic/scheduledRuns/requestScheduledRunOccurrencesEpic';
import { requestScheduledRunsEpic } from 'epic/scheduledRuns/requestScheduledRunsEpic';
import { rescheduleEpic } from 'epic/scheduledRuns/rescheduleEpic';
import { resetRunEpic } from 'epic/scheduledRuns/resetRunEpic';
import { updateScheduledQuotesEpic } from 'epic/scheduledRuns/updateScheduledQuotesEpic';
import { updateScheduledRunEpic } from 'epic/scheduledRuns/updateScheduledRunEpic';
import { validateQuotesEpic } from 'epic/scheduledRuns/validateQuotesEpic';
import { combineEpics } from 'redux-observable';
export const scheduledRunEpic = () =>
  combineEpics(
    withAppCrashIfException('createScheduledRunEpic', createScheduledRunEpic()),
    withAppCrashIfException('addToScheduledRunEpic', addToScheduledRunEpic()),
    withAppCrashIfException('updateScheduledQuotesEpic', updateScheduledQuotesEpic()),
    withAppCrashIfException('checkNameEpic', checkNameEpic()),
    withAppCrashIfException('requestScheduledRunsEpic', requestScheduledRunsEpic()),
    withAppCrashIfException('requestScheduledRunOccurrencesEpic', requestScheduledRunOccurrencesEpic()),
    withAppCrashIfException('requestScheduledRunOccurrenceDetailEpic', requestScheduledRunOccurrenceDetailEpic()),
    withAppCrashIfException('updateScheduledRunEpic', updateScheduledRunEpic()),
    withAppCrashIfException('pauseScheduledRunEpic', pauseScheduledRunEpic()),
    withAppCrashIfException('rescheduleEpic', rescheduleEpic()),
    withAppCrashIfException('deleteScheduledRunEpic', deleteScheduledRunEpic()),
    withAppCrashIfException('resetRunEpic', resetRunEpic()),
    withAppCrashIfException('validateQuotesEpic', validateQuotesEpic()),
  );
